import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AUTHORIZED_ACCOUNT_LABEL } from '../../../../../globalTypes/account.types';

@Component({
  selector: 'msh-name-tag',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex items-center"
         [ngClass]="{
           'flex-row': imagePosition === 'left',
           'flex-row-reverse': imagePosition === 'right'
         }">
      @if(isVerified){
        <img class="w-4 h-4 ml-2" src="certified_badge.png" [alt]="AUTHORIZED_ACCOUNT_LABEL" />
      }
      @if(url){
        <!-- Circle Image -->
        <div [ngClass]="circleSizeClasses" class="flex-shrink-0 rounded-full overflow-hidden bg-gray-200">
          <img [src]="url"
              [alt]="label"
              class="w-full h-full object-cover" />
        </div>
      } @else {
        <div [ngClass]="circleSizeClasses" class="flex-shrink-0 rounded-full overflow-hidden bg-navy/25 flex items-center justify-center font-bold text-white">
          {{ initials }}
        </div>
      }
      @if(label){
        <!-- Label -->
        <div class="ml-3 mr-3"
            [ngClass]="labelSizeClasses">
          @if(owner){
            {{ owner + ' - ' }}
          }
          {{ label }}
        </div>
      }
    </div>
  `,
  styles: [``]
})
export class NameTagComponent implements OnInit {
  @Input() isVerified: boolean = false;
  @Input() url?: string = '';
  @Input() label?: string = '';
  @Input() owner?: string = '';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() imagePosition: 'left' | 'right' = 'left';
  AUTHORIZED_ACCOUNT_LABEL = AUTHORIZED_ACCOUNT_LABEL
  initials = '--';

  ngOnInit() { 
    if(this.label) {
      const spl = this.label?.split(" ")
      this.initials = this.label.charAt(0) + spl[spl.length - 1].charAt(0)
    }
  }

  get circleSizeClasses(): string {
    switch (this.size) {
      case 'small': return 'w-8 h-8';
      case 'large': return 'w-16 h-16';
      default: return 'w-12 h-12'; // medium
    }
  }

  get labelSizeClasses(): string {
    switch (this.size) {
      case 'small': return 'text-sm';
      case 'large': return 'text-xl';
      default: return 'text-base'; // medium
    }
  }
}
